export default { version: 'v0.41.0' };
